import React, {useCallback} from 'react';
import Image from 'assets/svgs/common/default-image.svg';
import moment from 'moment';
import CopyIcon from 'assets/svgs/posts/copy.svg';

import DeleteIcon from 'assets/svgs/posts/delete.svg';
import DeleteRed from 'assets/svgs/actions/delete.svg';
import Revert from 'assets/svgs/actions/revert.svg';
import ActiveDeleteIcon from 'assets/svgs/posts/delete-white.svg';

import MoveIcon from 'assets/svgs/posts/move.svg';
import {LazyLoadImage} from 'react-lazy-load-image-component';
import Checkbox from 'components/Checkbox/Styled';
import {debounce} from 'utils/common';
import MoveCopy from '../MoveCopy';
import Label from '../Label';

const Row = ({
  post,
  onUpdateLabel,
  selected,
  onCheckboxChange,
  onUpdate,
  folders,
  onDelete,
  labels,
  countries,
}) => {
  const folder = folders.find((f) => f.value === post.categoryId);

  const country = countries.find((c) => c._id === post.companyId.country);

  const handleSlugChange = useCallback(
    debounce((single, text) => {
      onUpdate({...single, note: text});
    }, 1000),
    []
  );

  return (
    <>
      <tr className="bg-gray4">
        <td className="left-border-class p-0 pointer"></td>
        <td className="bg-gray4 text-center">
          <Checkbox checked={selected} handleChange={onCheckboxChange} />
        </td>
        <td className="post-img bg-gray4 px-0">
          <LazyLoadImage
            height={80}
            width={80}
            src={
              post.companyId?.logoId?.liveURL
                ? `${post.companyId.logoId.liveURL}`
                : Image
            }
          />
        </td>
        <td className="bg-gray4 px-0">
          <LazyLoadImage
            height={80}
            width={80}
            style={{padding: 20}}
            src={country ? `${country.avatar}` : Image}
          />
        </td>
        <td className="border-right-white bg-gray4">
          <p className="post-name m-0">{post.companyId.brandName}</p>
        </td>

        <td>{moment(post.createdAt).format('YYYY-MM-DD')}</td>
        <td className="note-table">
          <span
            style={{maxWidth: 220, whiteSpace: 'pre-wrap', display: 'block'}}
            suppressContentEditableWarning
            contentEditable
            onInput={(e) => handleSlugChange(post, e.currentTarget.innerText)}
          >
            {post.note}
          </span>
        </td>
        <td className="text-center role-btn">
          <span className="text-capitalize py-2 px-3 border bg-white">
            {folder ? folder.label : 'Custom'}
          </span>
        </td>

        <td className="text-center">
          <div className="d-flex align-items-center">
            <Label
              postLabel={post.label}
              onChange={(label) => {
                onUpdateLabel(label);
              }}
              labels={labels}
            />
          </div>
        </td>
        <td className="text-right">
          <div
            className={`d-flex link-icon justify-content-${
              post.isTrashed ? 'center' : 'around'
            } filters-middle align-items-center`}
          >
            {post.isTrashed ? (
              <>
                <a
                  href="#s"
                  className="no-border"
                  onClick={(e) => {
                    e.preventDefault();
                    const newPost = {...post, isTrashed: false};
                    onUpdate(newPost);
                  }}
                >
                  <img height={16} alt="" src={Revert} className="inactive" />
                </a>
              </>
            ) : (
              <>
                <MoveCopy
                  setSelected={(e) => {
                    const newPost = {
                      ...post,
                      categoryId: e.value === 'custom' ? null : e.value,
                    };
                    onUpdate(newPost);
                  }}
                  folders={folders.map((single) => ({
                    ...single,
                    isDisabled: post.categoryId === single.value,
                  }))}
                  icon={MoveIcon}
                />

                <MoveCopy
                  setSelected={(e) => {
                    const newPost = {
                      ...post,
                      categoryId: e.value === 'custom' ? null : e.value,
                      _id: undefined,
                    };

                    onUpdate(newPost);
                  }}
                  folders={folders.map((single) => ({
                    ...single,
                    isDisabled: post.categoryId === single.value,
                  }))}
                  icon={CopyIcon}
                />
              </>
            )}

            <a
              href="#dd"
              className="no-border ml-0 justify-content-start"
              onClick={(e) => {
                e.preventDefault();
                onDelete(post);
              }}
            >
              <img
                alt=""
                height={16}
                src={post.isTrashed ? DeleteRed : DeleteIcon}
                className="inactive"
              />
              <img alt="" src={ActiveDeleteIcon} className="active" />
            </a>
          </div>
        </td>
      </tr>
    </>
  );
};

export default Row;
